import { useContext } from 'react';
// import AuthContext from 'src/contexts/JWTAuthContext';
import AuthContext from '../contexts/Auth0Context';

const useAuth = () => useContext(AuthContext);

export default useAuth;
